import { decorateFormChoices } from '@/components/choices.js'
import { manageMobileMenu } from '@/components/mobileMenu'
import { lazyImages } from '@/components/lazyImages'
import { main as submitForm } from '@/components/submitForm'
import { init as animate } from '@/components/animate'

animate()
submitForm()
lazyImages()
manageMobileMenu()
decorateFormChoices()
